// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__OfZBt","notes":"Notes_notes__2vJ5F","note":"Notes_note__1jW-m","markdown":"Notes_markdown__3S5gu"};